import React from 'react';
import styled from 'styled-components';

import Backdrop from '@material-ui/core/Backdrop/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';

interface Props {
  loading?: boolean;
  dimBackground?: boolean;
}

export const LoadingBackdrop: React.FC<Props> = ({ loading, dimBackground = true }) =>
  loading ? (
    <StyledBackdrop open={loading} dimBackground={dimBackground}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  ) : null;

interface BackdropProps {
  className?: string;
  open: boolean;
  dimBackground?: boolean;
}

const CustomBackdrop: React.FC<BackdropProps> = ({ className, open, children }) => (
  <Backdrop open={open} className={className}>
    {children}
  </Backdrop>
);

const StyledBackdrop = styled(CustomBackdrop)`
  ${({ theme, dimBackground }) => `
  z-index: ${theme.zIndex.backdrop};
  color: ${dimBackground ? theme.colors.lightGrey1 : theme.colors.brandMediumGrey};
  ${!dimBackground && 'background-color: transparent;'}
 `}
`;
